import React, { useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { number } from '~/helpers';

import { UnidataTable } from '~/components';

import {
  recordFiltering,
} from '~/store/modules/operacaoradrelatoriopesquisaprefaturaunidata/actions';

function OperacaoRadRelatorioPesquisaPreFaturaUnidataLista() {

  const operacaoradrelatoriopesquisaprefaturaunidata = useSelector(
    (state) => state.operacaoradrelatoriopesquisaprefaturaunidata
  );

  const status = useMemo(() => [
    { value: 'Aguardando Aprovação Gestor do Órgão', label: '1' },
    { value: 'Aguardando Emissão', label: '0' },
    { value: 'Aguardando Emissão da Fatura', label: '5' },
    { value: 'Aguardando Emissão Pedido de Faturamento', label: '4' },
    { value: 'Aprovado Gestor do Órgão', label: '201' },
    { value: 'Aprovado Gestor do Estado', label: '202' },
    { value: 'Cancelada por Contestação', label: '8' },
    { value: 'Contestação do Gestor do Órgão', label: '2' },
    { value: 'Contestação respondida pela Abastek', label: '3' },
    { value: 'Contestação do Gestor do Estado', label: '302' },
    { value: 'Contestação do Gestor do Estado respondida pela Abastek', label: '303' },
    { value: 'Fatura enviada para Órgão', label: '6' },
    { value: 'Fatura Paga', label: '7' },
    { value: 'Gestor do Estado Selecionou para Geração do Faturamento', label: '203' },
    { value: 'Vencida', label: '100' },
  ], []);

  const header = useMemo(() => [
    {
      id: 'orga_sigla',
      label: 'Órgão Sigla',
      align: 'left',
    },
    {
      id: 'fatu_codigo',
      label: 'Pré-fatura',
      filter: {
        type: 'text',
      },
      align: 'right',
    },
    {
      id: 'fatu_periodo',
      label: 'Período',
      align: 'center',
    },
    {
      id: 'fatu_datahora_geracao',
      label: 'Data Geração',
      align: 'center',
      formatted: (value) => (value !== '' ? value : '-'),
    },
    {
      id: 'fatu_status_str',
      label: 'Status',
      align: 'center',
      converter: status,
      filter: {
        type: 'select',
        options: status,
      },
    },
    {
      id: 'fatu_valor_servico',
      label: 'Valor do Serviço (R$)',
      formatted: (value) => number(value, 'currency'),
      align: 'right',
    },
    {
      id: 'fatu_valor_nota_fiscal',
      label: 'Valor Nota Fiscal (R$)',
      formatted: (value) => number(value, 'currency'),
      align: 'right',
    },
    {
      id: 'fatu_total_retencao',
      label: 'Total das retenções (R$)',
      formatted: (value) => number(value, 'currency'),
      align: 'right',
    },
    {
      id: 'usua_nome_gestor_validacao',
      label: 'Aprovado por',
      align: 'left',
    },
    {
      id: 'fatu_datahora_validacao_gestor',
      label: 'Aprovado em',
      align: 'center',
      formatted: (value) => (value !== '' ? value : '-'),
    },
    {
      id: 'usua_login_cancelamento',
      label: 'Cancelado por',
      align: 'left',
    },
    {
      id: 'fatu_data_cancelamento',
      label: 'Cancelado em',
      align: 'center',
      formatted: (value) => (value !== '' ? value : '-'),
    },
    {
      id: 'fatu_numero_pedido',
      label: 'Pedido',
      filter: {
        type: 'text',
      },
      align: 'right',
    },
    {
      id: 'fatu_data_envio_fatura',
      label: 'Data do Pedido',
      align: 'center',
      formatted: (value) => (value !== '' ? value : '-'),
    },
    {
      id: 'fatu_nota_fiscal',
      label: 'Nota Fiscal',
      filter: {
        type: 'text',
      },
      align: 'right',
    },
    {
      id: 'fatu_data_fatura',
      label: 'Data Envio NF',
      align: 'center',
      formatted: (value) => (value !== '' ? value : '-'),
    },
    {
      id: 'fatu_data_vencimento',
      label: 'Data Vencimento NF',
      align: 'center',
      formatted: (value) => (value !== '' ? value : '-'),
    },
    {
      id: 'fatu_data_pagamento',
      label: 'Pago em',
      align: 'center',
      formatted: (value) => (value !== '' ? value : '-'),
    },
    {
      id: 'fatu_dias_vencimento',
      label: 'Dias Para Vencimento',
      align: 'right',
      styled: (value) => value < 0 ? ({ color: '#ff0000' }) : ({ color: '#00B300' }),
    },
    {
      id: 'fatu_dias_pagto_apos_vencimento',
      label: 'Pagos após vencimento',
      align: 'right',
    },
  ], []);

  const filter = useMemo(() => [
    {
      id: 'orga_codigo',
      label: 'Órgão',
      type: 'autocomplete',
      autocomplete: {
        url: 'orgaos',
        label: 'orga_nome',
        unique: 'orga_codigo',
        params: {
          fieldlist: 'orga_codigo, orga_nome',
        }
      }
    }
  ], []);

  return (
    <>
      <UnidataTable
        create={false}
        delete={false}
        update={false}
        fixed
        header={header}
        redux={operacaoradrelatoriopesquisaprefaturaunidata}
        read={recordFiltering}
        detach="fatu_codigo"
        custom={filter}
      />
    </>
  );
}

export default OperacaoRadRelatorioPesquisaPreFaturaUnidataLista;
